

























import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import FormButtons from "@/general/abstract/form/FormButtons.vue";

@Component({
  components: { FormButtons }
})
export default class FormBase extends Vue {
  @Prop({ default: "" }) title!: string;
  @Prop({ default: false }) submitting!: boolean;
  @Prop({ default: undefined }) elevation!: number | string;
  @Prop({ default: false }) submittingDisabled!: boolean;
  @Prop({ default: false }) hideGoBackButton!: boolean;
}
